export default __webpack_public_path__ + "static/media/NOT FOUND.cfca745f.gif";